<template>
  <div class="leave-table table-responsive-sm mt-md-3 px-md-3">
    <table
      class="table leave-tabel-main table-borderless pl-md-5"
      v-if="data.length"
    >
      <thead class="leave-tabel-head">
        <tr>
          <th
            scope="col"
            v-for="(col, index) in fields"
            :key="index"
            :class="col == 'edit' || col == 'delete' ? 'text-center' : ''"
          >
            {{ $t(`global.table.${col}`) }}
          </th>
        </tr>
      </thead>
      <tbody class="leave-tabel-body">
        <tr v-for="(obj, index) in data" :key="index">
          <td class="text-left">
            {{ obj.employee.firstName }} {{ obj.employee.lastName }}
          </td>
          <td class="text-left">
            {{ formatDate(obj.dates.from) }}
          </td>
          <td class="text-left">
            {{ formatDate(obj.dates.to) }}
          </td>
          <td class="text-left">
            {{ obj.leaveType }}
          </td>
          <td class="text-left">
            {{ obj.comment }}
          </td>
          <td>
            <button
              type="button"
              class="mx-md-1 edit-btn"
              @click="editLeave(obj)"
            >
              {{ $t("task.view.edit") }}
              <img src="@/assets/images/edit-color.svg" />
            </button>
          </td>
          <td>
            <button
              type="button"
              class="mx-1 mx-md-1 del-btn"
              @click="deleteLeave(obj.reference)"
            >
              {{ $t("task.view.delete") }}
              <i class="fa fa-trash" aria-hidden="true"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="no-leave" v-else>
      <h3>No Data Found</h3>
    </div>
  </div>
</template>
<script>
import TimeUtils from '../../utils/TimeUtils';

export default {
  props: {
    data: {
      type: Array,
    },
    fields: {
      type: Array,
    },
  },

  methods: {
    formatDate(date) {
      return TimeUtils.dayMonYearNumber(date);
    },

    editLeave(leave) {
      this.$emit('showLeave', leave);
    },

    deleteLeave(reference) {
      this.$emit('removeLeave', reference);
    },
  },
};
</script>
<style lang="scss" scoped>
.leave-table {
  height: auto;
  @media (min-width: 320px) and (max-width: 767px) {
    padding: 0 10px;
  }
  .leave-tabel-main {
    .leave-tabel-head {
      tr {
        border-bottom: 1px solid #ddd;
        grid-template-columns: 14% 14% 14% 14% 14% 14% 15%;
        display: grid;
        th {
          color: #303778;
          font-family: "SF-Pro-Text";
          font-size: 12px;
          text-align: left;
        }
      }
    }
    .leave-tabel-body {
      tr {
        cursor: pointer;
        border-bottom: 1px solid #ddd;
        grid-template-columns: 14% 14% 14% 14% 14% 14% 15%;
        display: grid;
        td {
          color: #212529;
          font-family: "SF-Pro-Text";
          padding-top: 7px;
          padding-bottom: 7px;
          a {
            border: 1px solid #4f78e2;
            color: #4f78e2;
            padding: 6px 10px;
            border-radius: 4px;
            display: inline-block;
            width: 100%;
            margin: 0 auto;
            text-align: center;
            font-family: "SF-Pro-Text";
          }
        }
      }
    }
  }
}
.no-leave {
  padding-top: 20px;
  padding-left: 15px;
}
.del-btn {
  border: 1px solid red;
  background-color: transparent;
  padding: 4px 15px;
  border-radius: 3px;
  color: red;
  font-family: "SF-Pro-Text";
  font-weight: 500;
  font-size: 14px;
  outline: none !important;
  outline: none !important;
  @media (min-width: 320px) and (max-width: 600px) {
    font-size: 12px;
    padding: 3px 10px;
  }
}
.edit-btn {
  border: 1px solid #4f78e2;
  background-color: transparent;
  padding: 4px 15px;
  border-radius: 3px;
  color: #4f78e2;
  font-family: "SF-Pro-Text";
  font-weight: 500;
  font-size: 14px;
  outline: none !important;
  @media (min-width: 320px) and (max-width: 600px) {
    font-size: 12px;
    padding: 3px 10px;
  }
  img {
    width: 15px;
    vertical-align: sub;
  }
}
</style>
